'use strict'

import React      from 'react'
import API        from '../services/api'
import Calculator from '../assets/calculator'

export default class FullSummaryPage extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      packages: [],
      activePackage: 1
    }

    this.calcClicked.bind(this)
  }

  componentWillMount () {
    let api = new API()
    api.getPackages().then((result) => {
      this.setState({
        packages: result
      })
    })
  }

  setActivePackage (packageNumber) {
    this.setState({
      activePackage: packageNumber
    })
  }

  changePackage (dentalPackage) {
    const { showSecondForm, onChange } = this.props

    onChange('dental-package', {
      displayName: 'Package',
      value: dentalPackage.name,
      pageRef: '',
      order: 7
    })

    showSecondForm()
  }

  buttonClassList (packageNumber) {
    const { activePackage } = this.state
    let classList

    if (packageNumber === activePackage) {
      classList = 'summary-package package-active'
    } else {
      classList = 'summary-package'
    }

    return classList
  }

  showSecondForm (e) {
    e.preventDefault()

    window.ga('send', 'event', {
      eventCategory: 'Recommendation',
      eventAction: 'Click',
      eventLabel: 'Main Start'
    })

    this.props.showSecondForm()
  }

  calcClicked () {
    window.ga('send', 'event', {
      eventCategory: 'Recommendation',
      eventAction: 'Click',
      eventLabel: 'Sidebar Start'
    })
  }

  componentDidMount () {
    window.ga('send', {
      hitType: 'pageview',
      page: 'Quote summary page'
    })
  }

  render () {
    const { packages } = this.state

    // we need packages before we render
    if (!packages.length) return (<div></div>)

    /*
      id: 'aushd'
      name: 'Smile'
      paymentWeeks: 9
      voucherPrice: 891
      voucherSaving: 109
      voucherValue: 1000
      weeklyPayment: 99
    */

    const quotes = {
      'Implants / Crowns': {
        'Less than 2 years': 4000,
        '2 - 5 years': 5000,
        '5 - 10 years': 5000,
        '10+ years': 10000
      },
      'Replace Missing Teeth': {
        'Less than 2 years': 3000,
        '2 - 5 years': 4000,
        '5 - 10 years': 4000,
        '10+ years': 5000
      },
      'Fillings': {
        'Less than 2 years': 2000,
        '2 - 5 years': 3000,
        '5 - 10 years': 3000,
        '10+ years': 4000
      },
      'Whitening': {
        'Less than 2 years': 1000,
        '2 - 5 years': 2000,
        '5 - 10 years': 2000,
        '10+ years': 3000
      },
      'Cosmetic': {
        'Less than 2 years': 2000,
        '2 - 5 years': 2000,
        '5 - 10 years': 3000,
        '10+ years': 3000
      },
      'Others': {
        'Less than 2 years': 2000,
        '2 - 5 years': 3000,
        '5 - 10 years': 3000,
        '10+ years': 4000
      }
    }

    const weeks = {
      '1000': 9,
      '2000': 18,
      '3000': 27,
      '4000': 36,
      '5000': 45,
      '10000': 60
    }

    let packageAmount = 1000

    let needed = this.props.summary['know-whats-needed'].value
    let lastVisit = this.props.summary['last-visit'].value

    for (let i in needed) {
      if (quotes[needed[i]][lastVisit] > packageAmount) {
        packageAmount = quotes[needed[i]][lastVisit]
      }
    }

    return (
      <div>
        <div className='container'>
          <div className='row'>
            <h2 className='header outline'>Recommendation</h2>
            <div className='half'>
              <div className='package-headline black-color-text'>
                We suggest you will need a $
                {packageAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} package.
              </div>
              <div>
                <div className='summary-package'>
                  ${packageAmount === 10000 ? 150 : 99} / Week
                </div>
                <div className='summary-package'>
                  {weeks[packageAmount.toString()]} Weeks
                </div>
              </div>
              <button onClick={this.showSecondForm.bind(this)} className='summary-button full-width'>
                START
              </button>
              <p className='summary-p'>
                Want more dental work done? Want to lower your weekly payments or need your dental work done faster? Use our <span className='highlight'>voucher calculator</span>          to tailor your dental package.
              </p>
            </div>
            <div className='half'>
              <Calculator
                onStart={this.calcClicked}
                onChange={this.props.onChange}
                showForm={this.props.showSecondForm}
                amount={packageAmount === 10000 ? 150 : 99}
                package={[1000, 2000, 3000, 4000, 5000, 10000].indexOf(packageAmount)} />
            </div>
            <div className='half'>
              <h2 className='summary-example'>
                Example of what could be included in my ${packageAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} voucher
              </h2>
              <p>
                When needing to get a sizeable dental procedure done it can be hard to save for. At Dental Members Australia we give Australians the opportunity to get the treatment
                they need through manageable weekly payments
              </p>
              <div className='summary-info'>
                This is not a loan, this is a no risk, no interest dental payment plan.
              </div>
              <p>
                We connect you the patient to quality dentists who also believe that dentistry should be more accessible and affordable.
              </p>
            </div>
          </div>
        </div>
        <script src='//cdn-static.formisimo.com/tracking/js/conversion.js'></script>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/form-segments/full-summary-page.js